import { LANDING_FOOTER } from "@/pages/home/landingContent";

// La versión sale de apps/client/package.json en el build (define de Vite).
// Fuera de Vite (tests) la constante no existe: se omite.
const APP_VERSION = typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "";

export function LandingFooter() {
  const parts = [LANDING_FOOTER.product, `© ${new Date().getFullYear()}`];
  if (APP_VERSION) parts.push(`v${APP_VERSION}`);

  return (
    <footer className="relative flex-none border-t border-white/15">
      <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-1 px-4 py-1.5 text-center text-xs leading-snug text-white/80 md:px-8 md:py-2.5">
        <span>{parts.join(" · ")}</span>
        <span aria-hidden="true">·</span>
        <span className="inline-flex items-center gap-1.5">
          {LANDING_FOOTER.by}
          <img src="/assets/logo-adf.svg" alt={LANDING_FOOTER.adfLogoAlt} className="h-[0.8125rem] w-auto opacity-80" />
        </span>
      </div>
    </footer>
  );
}
